module.exports = __webpack_public_path__ + "img/icon-headphone.2946ce29.svg";